import { formatDate } from 'src/utils';
import type { MiraElement } from '@shared/types/mira';

export const defaultFormatter = (val: string) => val;

export const getMiraElementFormatter = (
  miraResponseFieldName: keyof MiraElement
): ((val: string) => string) => {
  switch (miraResponseFieldName) {
    case 'LRTAcquisitionDate':
    case 'ProdDate':
    case 'RedeliveryDateTime':
      return formatDate;
    default:
      return defaultFormatter;
  }
};
